module.exports = __webpack_public_path__ + "media/images/common/search_btn_s-7109411523e6076efb5f99d90a2ae50a.png";